import { useNavigate, useLocation } from "react-router-dom";
import CustomButton from '../Button';
import { UtilityFunctions } from "../../../utils";

function BackButton() {
    const navigate = useNavigate();
    const location = useLocation();

    const handleClick = () => {
        const previousPath = UtilityFunctions.backToPreviousPath(location.pathname)
        navigate(previousPath)
        return
    }

    return (
        <CustomButton title={"Geri"} onClick={handleClick} variant={'neutral'} disabled={location.pathname === '/factory'}/>
    );
}

export default BackButton;
